import React, { useState } from "react";
import "./App.css";

const BASE_AMOUNT = 256; 

const PayFastForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    cellphoneNumber: "",
    quantity: 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === "quantity" ? Number(value) : value,
    });
  };

  const calculatedAmount = BASE_AMOUNT * formData.quantity;

  return (
    <div>
      <div className="div">
        <h1>Registration Form</h1>
      </div>

      <form
        name="PayFastPayNowForm"
        action="https://payment.payfast.io/eng/process"
        method="post"
        className="form-container"
      >
        <h2>Personal Information</h2>

        <div>
          <label>First Name *</label>
          <input required type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
        </div>

        <div>
          <label>Last Name *</label>
          <input required type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
        </div>

        <div>
          <label>Email Address *</label>
          <input required type="email" name="email" value={formData.email} onChange={handleChange} />
        </div>

        <div>
          <label>Cellphone Number *</label>
          <input required type="tel" name="cellphoneNumber" value={formData.cellphoneNumber} onChange={handleChange} />
        </div>

        <div>
          <label>Quantity *</label>
          <input required type="number" name="quantity" min="1" value={formData.quantity} onChange={handleChange} />
        </div>

        <p><strong>Total: R{calculatedAmount}</strong></p>

        <input type="hidden" name="cmd" value="_paynow" />
        <input type="hidden" name="receiver" value="11718503" />
        <input type="hidden" name="amount" value={calculatedAmount} />
        <input type="hidden" name="item_name" value="GirlCoder Club" />

        <input type="hidden" name="custom_str1" value={formData.firstName} />
        <input type="hidden" name="custom_str2" value={formData.lastName} />
        <input type="hidden" name="custom_str3" value={formData.email} />
        <input type="hidden" name="custom_str4" value={formData.cellphoneNumber} />
        <input type="hidden" name="custom_int1" value={formData.quantity} />

        <div className="submit-button-container">
          <input
            type="image"
            src="https://my.payfast.io/images/buttons/PayNow/Primary-Large-PayNow.png"
            alt="Pay Now"
            title="Pay Now with PayFast"
          />
        </div>
      </form>
    </div>
  );
};

export default PayFastForm;